import { render, staticRenderFns } from "./EocPortalAccessCard.vue?vue&type=template&id=140b693e&scoped=true&"
import script from "./EocPortalAccessCard.vue?vue&type=script&lang=js&"
export * from "./EocPortalAccessCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140b693e",
  null
  
)

export default component.exports